import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { CurrentUserSelectors } from '@recruitee/account-data';
import { filterBoolean } from '@recruitee/common';
import { FeatureDiscoveryFeatures } from '@recruitee/feature-discovery-types';

@Injectable({ providedIn: 'root' })
export class CurrentUserService {
  public currentUser$ = this.store.select(CurrentUserSelectors.data).pipe(filterBoolean);

  constructor(private store: Store) {}

  public featureDiscovered(feature: keyof FeatureDiscoveryFeatures) {
    return this.currentUser$.pipe(map(currentUser => currentUser.featureDiscovery[feature]));
  }
}
